import { useEffect, useState } from 'react';
import styles from './Header.module.scss';

export function Header() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const scroll_size = 50;
    const onScroll = () => setIsVisible(window.scrollY >= scroll_size);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`${styles.header} ${isVisible ? styles.headerVisible : ''}`} aria-hidden={!isVisible}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.brand}>
          <span className={styles.dot} />
          <span>Rapolas Skripkauskas</span>
        </div>
        <nav className={styles.nav} aria-label="Primary">
          <a className={styles.link} href="#about">About</a>
          <a className={styles.link} href="#tech">Tech</a>
          <a className={styles.link} href="#experience">Experience</a>
          <a className={styles.link} href="#projects">Projects</a>
          <a className={styles.link} href="#contact">Contact</a>
        </nav>
      </div>
    </header>
  );
}